import $ from 'jquery';
var fileList;
class Results {

    constructor(){
        fileList = this.getFileList(this);
        this.events();  
    }

    events() {
        //  Register Listeners
        $("#year-dropdown").on("change", this.yearChanged.bind(this));
        $("#series-dropdown").on("change", this.seriesChanged.bind(this));
        $("#event-dropdown").on("change", this.eventChanged.bind(this));
    }


    //  Methods
    yearChanged(e){
        buildSeriesArray(fileList,$("#year-dropdown").val());
    }
    seriesChanged(e){
        buildEventsArray(fileList,$("#year-dropdown").val(),$("#series-dropdown").val());
    }
    eventChanged(e){
        setIframe_src();
    }
    
    getFileList(){  //Get List of results files from Server
        $.ajax({
            beforeSend:(xhr) => {
                xhr.setRequestHeader('X-WP-Nonce',dysData.nonce);
            },
            url: dysData.root_url + '/wp-json/results/v1/fileList/',
            type: 'POST',
            success: (response) => {
                breakdownFileList(response);
                
            },
            error: (response) => {
                console.log("Invalid Data Response");
                console.log(response);
            }
        });
    }
}

window.checkSize = function(){

    //$("#results-frame").width(1000);
    $("#results-frame").height($("#results-frame").contents().height());

    if ($("#results-frame").contents().width() > $(".results-frame-container").width()){
        $("#results-frame").width($("#results-frame").contents().width());
    } else {
        $("#results-frame").width($(".results-frame-container").width());
    }
}

function breakdownFileList(response){
    fileList = JSON.parse(response);
    buildYearsArray(fileList);
}
function buildYearsArray(fileList){
    var allYears = [];
    var currentYear="";
    var fileName

    $('#year-dropdown').empty();
    for (var i=0; i<fileList.length; i++){
        fileName = fileList[i].split('-');
        if (currentYear != fileName[0]){
            allYears.push(fileName[0]);
            currentYear = fileName[0];
        }
    }
    allYears.sort();
    allYears.reverse();
    for (var i=0; i< allYears.length; i++){
        $('#year-dropdown').append('<option value="' + allYears[i] + '">' +  allYears[i] + '</option>');
    }
    currentYear = allYears[0];
    buildSeriesArray(fileList, currentYear);
}
function buildSeriesArray(fileList, currentYear){
    var allSeries = [];
    var currentSeries = "";
    var fileName

    $('#series-dropdown').empty();
    for (var i=0; i<fileList.length; i++){
        fileName = fileList[i].split('-');
        if (currentYear == fileName[0]){
            if (currentSeries != fileName[1]){
                allSeries.push(fileName[1]);
                currentSeries = fileName[1];
                $('#series-dropdown').append('<option value="' + currentSeries + '">' + currentSeries + '</option>');
            }
        }
    }
    currentSeries = allSeries[0];
    var allEvents = buildEventsArray(fileList, currentYear, currentSeries);
}

function buildEventsArray(fileList, currentYear, currentSeries){
    var allEvents = [];
    var currentEvent = "";
    var fileName;
    var fileEvent;
    var containsOverall = "";

    $('#event-dropdown').empty();
    for (var i=0; i<fileList.length; i++){
        fileName = fileList[i].split('-');
        fileEvent = fileName[2].split('.');
        if (currentYear == fileName[0]){
            if (currentSeries == fileName[1]){
                if (currentEvent != fileEvent[0]){
                    allEvents.push(fileEvent[0]);
                    currentEvent = fileEvent[0];
                    if (currentEvent.indexOf("verall") !== -1){
                        containsOverall=currentEvent;
                    }
                }
            }
        }
    }
    if (containsOverall){
        $('#event-dropdown').append('<option value="' + containsOverall + '">' + containsOverall + '</option>');
    }
    for (var i=0; i< allEvents.length; i++){
        if (allEvents[i].indexOf("verall") === -1){
            $('#event-dropdown').append('<option value="' + allEvents[i] + '">' + allEvents[i] + '</option>');
        }
    }

    currentEvent = allEvents[0];
    setIframe_src();

}
function setIframe_src(){
    var today = new Date();
    var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
    var src='../wp-content/uploads/Results/' + $('#year-dropdown').val() + '-' + $('#series-dropdown').val() + '-' +  $('#event-dropdown').val() + '.htm';
    $('#results-frame').attr('src',src);
}

export default Results;